import { ComponentTypes } from '@wix/editor-const';

export const EXPERIMENT_SE_WP_RESP_CONTAINER_LAYOUT =
  'se_wp_resp_container_layout';

export const IFRAME_WIDGET = 'WIDGET';
export const IFRAME_PAGE = 'PAGE';
export const BUILDER_WIDGET = 'EDITOR_REACT_COMPONENT';
export const OOI_WIDGET = 'WIDGET_OUT_OF_IFRAME';
export const OOI_PAGE = 'PAGE_OUT_OF_IFRAME';
export const BLOCKS_WIDGET = 'STUDIO_WIDGET';
export const CE_WIDGET = 'CUSTOM_ELEMENT_WIDGET';
export const VIRTUAL_OOI_SLOT_SEPARATOR = '_vs_';
export const SLOT_ID_DIVIDER = '_r_';
export const DEFAULT_BLOCKS_SLOT_KEY_NAME = 'slot';

export const SUPPORTED_TPA_HOST_PLUGIN_COMPONENT_TYPES = [
  ComponentTypes.TpaWidget,
  ComponentTypes.TpaSection,
  ComponentTypes.TpaMultiSection,
];

export const SUPPORTED_BLOCKS_HOST_PLUGIN_COMPONENT_TYPES = [
  ComponentTypes.RefComponent,
];

export enum ComponentPreviewState {
  HIGHLIGHTED = 'highlighted',
}

export const HEADER_SYSTEM_SLOT = {
  id: 'd221226b-f738-450c-a3a2-a3853142a614',
  compType: 'wixSystemElements.SystemHeaderSlot',
  appDefinitionId: '88110a9d-ba44-450e-bcf9-17058af00b76',
};

// Reference width (px) used by the spx scale resolver to compute spx-based sizes.
export const SPX_REFERENCE_WIDTH = 1280;

// Effectively-unbounded spx dimension used for header layout max-width/height.
export const MAX_SPX_DIMENSION = 99999;
